import { render, staticRenderFns } from "./HasilReview.vue?vue&type=template&id=2fd14d23&scoped=true&lang=html&"
import script from "./HasilReview.vue?vue&type=script&lang=js&"
export * from "./HasilReview.vue?vue&type=script&lang=js&"
import style0 from "./HasilReview.vue?vue&type=style&index=0&id=2fd14d23&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd14d23",
  null
  
)

export default component.exports